import { MarketHours } from './MarketHours';
import { WorldClock } from './WorldClock';
import { OpeningBell } from './OpeningBell';

interface HeaderProps {
  lastUpdate: string;
}

export function Header({ lastUpdate }: HeaderProps) {
  return (
    <header className="header">
      <div className="header-left">
        <h1>CHRONOS</h1>
      </div>

      <div className="header-center">
        <div className="status">
          <span className="status-indicator online"></span>
          <span>Backend: Online</span>
        </div>
        <MarketHours />
        <OpeningBell />
        <button
          className="buzz-link"
          onClick={() => document.getElementById('buzz')?.scrollIntoView({ behavior: 'smooth' })}
        >
          Buzz ↓
        </button>
      </div>

      <div className="header-right">
        <WorldClock />
        <p className="last-update">Last scan: {lastUpdate || 'Loading...'}</p>
      </div>
    </header>
  );
}
